<template>
  <div
    class="plans-cycle-switch"
    :class="{disabled: disabled}"
  >

    <can-get-extra-free-tooltip
      v-if="canGetExtraFree"
      :placement="isRTL ? 'right' : 'left'"
      target="annually-cycle-label"
    />
    <div
      id="annually-cycle-label"
      class="plan-cycle"
      :class="{active: value === 'yearly'}"
    >
      {{ $t('payment.annually') }}
    </div>
    <b-form-checkbox
      :checked="value"
      :value="'monthly'"
      :unchecked-value="'yearly'"
      inline
      switch
      :disabled="disabled"
      class="switch-size-lg"
      @change="$emit('input', $event)"
    />
    <div
      class="plan-cycle"
      :class="{active: value === 'monthly'}"
    >
      {{ $t('payment.monthly') }}
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import CanGetExtraFreeTooltip from '@/views/admin/purchase/components/CanGetExtraFreeTooltip'

export default {
  name: 'PlansCycleSwitch',
  components: { CanGetExtraFreeTooltip, BFormCheckbox },
  props: {
    value: {
      type: String,
      default: 'yearly',
      validations: v => ['monthly', 'yearly'].includes(v),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isRTL: 'appConfig/isRTL',
      canGetExtraFree: 'subscription/canGetExtraFree',
    }),
  },
}
</script>

<style lang="scss">
.plans-cycle-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 18px;
  min-height: 28px;

  .plan-cycle {
    color: var(--description-color);
    font-size: 16px;
    display: inline;

    &.active {
      color: var(--purple);
      font-weight: 600;
    }
  }

  .custom-switch {
    margin: 0 7px!important;

    .custom-control-label::after {
      background-color: var(--light-green)!important;
      left: 6px;
    }

    .custom-control-label::before {
      background-color: transparent!important;
      border: 3px solid var(--light-green) !important;
    }

    .custom-control-input:checked ~ .custom-control-label::before, & .custom-control-input:active ~ .custom-control-label::before {
      border: 3px solid var(--light-green) !important;
    }

    .custom-control-input:checked[disabled] ~ .custom-control-label::before, [dir] .custom-control-input:active:disabled ~ .custom-control-label::before {
      opacity: 0.5;
    }
  }

  &.disabled {
    opacity: 0.5;
  }
}
</style>
